export { useCampaigns, useCampaignTagsForProduct } from "./hooks";
export { getCampaignTagsForProduct, type Campaign, type CampaignTagInfo } from "./dal";
export { ProductCardWithCampaigns } from "./ProductCardWithCampaigns";